module.exports = __webpack_public_path__ + "images/emoji/pager.9a474eddedef1aa37441.png";